import { createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../_virtual/_rollupPluginBabelHelpers.js';

var pointsPriceByID = function pointsPriceByID(pointsPrices, id) {
  if (!pointsPrices) {
    return null;
  }
  for (var _iterator = _createForOfIteratorHelperLoose(pointsPrices), _step; !(_step = _iterator()).done;) {
    var pointPrice = _step.value;
    if (pointPrice.id === id) {
      return pointPrice;
    }
  }
  return null;
};
var getPriceSplit = function getPriceSplit(pointPrices, exVat, price) {
  var split = [];
  var currVat = exVat ? "exVat" : "incVat";
  if (!pointPrices) {
    if (!price) {
      return null;
    }
    split.push({
      type: "currency",
      values: {
        currency: price[currVat]
      }
    });
    return split;
  }
  var points = pointPrices.points,
    currency = pointPrices.currency;
  if (points.max[currVat] >= points.value[currVat] && points.value[currVat] > 0 && points.max[currVat] > 0) {
    split.push({
      type: "points",
      values: {
        points: points.value[currVat]
      }
    });
  }
  if ((points.min[currVat] > 0 || currency.min[currVat] > 0) && currency.max[currVat] > 0) {
    split.push({
      type: "split",
      values: {
        points: points.min[currVat],
        currency: currency.max[currVat]
      }
    });
  }
  if (currency.max[currVat] === currency.value[currVat] && currency.max[currVat] > 0) {
    split.push({
      type: "currency",
      values: {
        currency: currency.value[currVat]
      }
    });
  }
  return split;
};
var isPointsOnly = function isPointsOnly(pointsPrice) {
  if (!pointsPrice) {
    return false;
  }
  var currency = pointsPrice.currency;
  return currency.max.incVat === 0;
};

export { getPriceSplit, isPointsOnly, pointsPriceByID };
//# sourceMappingURL=points.js.map
